import hatIcon from "../assets/hat-icon.png";
import parentConnect from "../assets/parent-connect.png";
import { motion } from "framer-motion";
import RoundButton, {
  BtnType,
} from "heroic-ui-library/dist/components/RoundButton";
type Props = { onClose: () => void };

export default function TutorialFrame({ onClose }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="tutorial font-acme relative"
    >
      <RoundButton
        btnType={BtnType.close}
        onClick={onClose}
        size="small"
        className="!absolute !top-4 !right-4"
      />
      <div className="font-acme text-5xl text-center pt-2 mb-16">
        How to find your child's Code
      </div>

      <h2 className="text-4xl">Step 1:</h2>
      <p className="text-3xl mb-8">
        Have your Child login to their Heroic Game Day Account.
      </p>
      <div className="flex flex-row items-center mb-8">
        <div>
          <h2 className="text-4xl">Step 2:</h2>
          <span className="text-3xl mb-8 flex items-center">
            Open the game phone and Click the H.A.T. icon{" "}
          </span>
        </div>
        <img className="w-16 ml-4" src={hatIcon} />
      </div>
      <div className="flex flex-row items-center">
        <div>
          <h2 className="text-4xl">Step 3:</h2>
          <span className="text-3xl mb-8 flex items-center">
            Click Connect Parent
          </span>
        </div>
        <img className="w-64 ml-8" src={parentConnect} />
      </div>
      <div className=" ">
        <h2 className="text-4xl">Step 4:</h2>
        <p className="text-3xl mb-8 flex items-center">
          Use the code found on the page (the code expires so use it quickly)
        </p>
        <div></div>
      </div>
    </motion.div>
  );
}
